// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73dbc9f1","249":"aa106805","290":"866826ec","365":"1c6f7721","415":"aeabca44","453":"31b809bc","473":"b4ecde7b","483":"fbb94de7","643":"9a9979cf","779":"3a05056d"}[chunkId] + ".chunk.js";
};